import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";
import { deleteApiApplicationById } from "@actions/apiApplications.action";

const EditApiApplication = ({ apiApplicationId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.apiApplications.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteApiApplication = () => async () => {
    try {
      await dispatch(deleteApiApplicationById(apiApplicationId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/api-applications/${apiApplicationId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove User">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this user?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteApiApplication()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const ApiApplicationsTable = () => {
  const { apiApplications, fetching } = useSelector(({ apiApplications }) => apiApplications);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "application_name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Api Key",
        accessor: "api_key",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Created At",
        accessor: "created",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Updated At",
        accessor: "modified",
        isFiltered: true,
        isSorting: true,
      },
      {
        id: "colEdit",
        Cell: ({ row }) => <EditApiApplication apiApplicationId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => apiApplications, [apiApplications]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default ApiApplicationsTable;
